//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {}
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  methods: {
    submit() {
      let emitObj = {
        submitObj: {
          questionnaireId: this.item.tenantId,
        },
        callback: () => {
          this.$emit('popup-close')
        },
      }
      this.$emit('onsubmit', emitObj)
    },
    cancle() {
      this.$emit('popup-close')
    },
  },
}
